<app-navigation-bar></app-navigation-bar>

<main class="content" [class.hompage-bg]="isHomeRoute">
  <router-outlet #outlet="outlet"></router-outlet>
</main>
<!--<app-gdpr-modal *ngIf="isUserLoggedIn"></app-gdpr-modal>-->
<app-loader></app-loader>
<app-footer></app-footer>
